import { Button, Col, Tabs, Row, TableColumnType, Form, Space, Input, Select, Checkbox, Cascader } from "antd";
import { SearchOutlined, CaretDownFilled } from "@ant-design/icons";
import React, { ReactElement, useEffect, useRef, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import styles from "./recardDurg.module.css";
import {DateRangeFieldName, DateRangeType, DateSelect, getDateRange} from "../../../compnents/form/DateSelect";
import { RecevingParams } from "../../../services/receving";
import { pagePutstorageUser, setCategory } from "../../putstorage/putstorageSlice";
import { pageDurgsystem, selectDurgsystemData } from "../../durgsystem/durgsystemSlice";
import { sleectUserData } from "../../putstorelist/putstorelistSlice";
import { BillingCategoryName, InvoiceBillingCategories } from "../../../models/billingCategory";
import { FilterColumn } from "../../../compnents/filterForm/filterForm";
import { getMaterialsName, Materiales } from "../../../models/commodity";
import { getCommonCodeCompletionsAsync } from "../../completion/completionSlice";
import { unwrapResult } from "@reduxjs/toolkit";
import { CommonCodeCategory } from "../../../models/commoncode";
import { RootDispatch } from "../../../app/store";

const useCascaderDropdownRender = (
  treeData: any[],
  getValue: () => any[][],
  setValue: (v: any[][]) => void,
  onChange: () => void,
) => {
  return React.useCallback((menus: React.ReactNode) => {
    const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
      const target = e.target as HTMLElement
      const menuItem = target.closest('.ant-cascader-menu-item') as HTMLElement | null
      if (!menuItem) return
      const menu = menuItem.closest('.ant-cascader-menu') as HTMLElement | null
      if (!menu) return
      const menus = menu.parentElement?.querySelectorAll('.ant-cascader-menu')
      const menuIndex = menus ? Array.from(menus).indexOf(menu) : -1
      if (menuIndex !== 0) return
      if (target.closest('.ant-checkbox-wrapper')) return

      const labelEl = menuItem.querySelector('.ant-cascader-menu-item-content')
      const labelText = labelEl?.textContent?.trim()
      const topNode = treeData.find((v) => v.label === labelText)
      if (!topNode) return

      const currentValue: any[][] = getValue() || []
      const topVal = topNode.value

      const hasTop = currentValue.some((p) => p.length === 1 && p[0] === topVal)
      const children: any[] = topNode.children || []
      const allChildPaths = children.map((c: any) => [topVal, c.value])
      const allChildSelected = allChildPaths.every((cp) =>
        currentValue.some((p) => p[0] === cp[0] && p[1] === cp[1])
      )
      const isFullySelected = hasTop && (children.length === 0 || allChildSelected)

      let newValue: any[][]
      if (isFullySelected) {
        newValue = currentValue.filter((p) => p[0] !== topVal)
      } else {
        const withoutTop = currentValue.filter((p) => p[0] !== topVal)
        newValue = [...withoutTop, [topVal], ...allChildPaths]
      }

      setValue(newValue)
      onChange()
    }
    return <div onClick={handleClick}>{menus}</div>
  }, [treeData])
}

const normalizeMaterialsCategory = (value: any) => {
  if (!value) return []
  if (Array.isArray(value) && value.length === 0) return []
  if (Array.isArray(value) && Array.isArray(value[0])) return value
  if (Array.isArray(value)) return [value]
  return []
}

const getMaterialsCategoryParams = (value: any) => {
  const list = normalizeMaterialsCategory(value)

  const fullySelectedTopList = Array.from(
    new Set(
      list
        .filter((item: any) => Array.isArray(item) && item.length === 1)
        .map((item: any) => item?.[0])
        .filter((v: any) => v !== undefined && v !== null && v !== '')
    )
  )

  const fullySelectedSet = new Set(fullySelectedTopList.map((v: any) => String(v)))
  const childCategoryList = Array.from(
    new Set(
      list
        .filter((item: any) => Array.isArray(item) && item.length >= 2)
        .filter((item: any) => !fullySelectedSet.has(String(item?.[0])))
        .map((item: any) => item?.[1])
        .filter((v: any) => v !== undefined && v !== null && v !== '')
    )
  )

  const materialsCategory = fullySelectedTopList.join(',')
  const category = childCategoryList.join(',')

  return {
    materialsCategoryList: list.length ? list : undefined,
    materialsCategory: materialsCategory || undefined,
    category: category || undefined,
  }
}

export const RecardDrugQuery = (
  props: {
    exportloading: boolean;
    loading: boolean;
    filterColumn?: any[];
    filterSelectList?: any[];
    submitPageList?: (v: any) => void;
    onValueChange: (queries: RecevingParams) => void;
    outClued: () => void;
    continueOrder: (v: any, type: string) => void
  }): ReactElement => {
  const dispatch = useDispatch<RootDispatch>();
  const [form] = Form.useForm();
  const { Option } = Select;
  const durgData = useSelector(selectDurgsystemData);

  const userData = useSelector(sleectUserData);

  const [jzcxChecked, setJzcxChecked] = useState<any>()

  const [treeData, setTreeData] = useState<any>([])

  const recardDrugParams = JSON.parse(
    sessionStorage.getItem('/recardDrug-queries') || '{}'
  )

  const getYPFL = () => {
    const data = Materiales.map((v) => {
      return {
        id: v,
        value: v.toString(),
        label: getMaterialsName(v),
        children: [],
      }
    })

    dispatch(
      getCommonCodeCompletionsAsync({
        category: CommonCodeCategory.Durg,
        keyword: '',
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const tree = data.map((v) => {
          if (v.id == 0) {
            return {
              ...v,
              children: res.records.map((el: any) => ({
                value: el.codeName,
                label: el.codeName,
              })),
            }
          } else if (v.id == 1) {
            return {
              ...v,
              children: [
                { value: '材料', label: '材料' },
                { value: '器械', label: '器械' },
                { value: '消耗品', label: '消耗品' },
                { value: '其他', label: '其他' },
              ],
            }
          } else if (v.id == 2) {
            return {
              ...v,
              children: [
                { value: '第一类医疗器械', label: '第一类医疗器械' },
                { value: '第二类医疗器械', label: '第二类医疗器械' },
                { value: '第三类医疗器械', label: '第三类医疗器械' },
              ],
            }
          } else if (v.id == 4) {
            return {
              ...v,
              children: [
                { value: '食品', label: '食品' },
                { value: '化妆品', label: '化妆品' },
                { value: '保健品', label: '保健品' },
                { value: '卫生消毒用品', label: '卫生消毒用品' },
                { value: '初级农产品', label: '初级农产品' },
                { value: '其他产品', label: '其他产品' },
              ],
            }
          } else {
            return v
          }
        })

        setTreeData(tree)
      })
  }

  useEffect(() => {
    dispatch(pageDurgsystem(1, 100, 1));

    dispatch(pagePutstorageUser({ current: 1, size: 500 }));

    getYPFL();
  }, []);
  useEffect(() => {

    if (Object.keys(recardDrugParams).length) {
      form.setFieldsValue({
        ...recardDrugParams,
        materialsCategory: normalizeMaterialsCategory(recardDrugParams?.materialsCategoryList),
        timeHead: recardDrugParams?.timeHead,
        timeTail: recardDrugParams?.timeTail,
        [DateRangeFieldName]: recardDrugParams?._dateRange,
      })
    } else {
      const [head, tail] = getDateRange(DateRangeType.ThisMonth);
      form.setFieldsValue({
        timeHead: head,
        timeTail: tail,
      });
    }

    form.submit();
  }, []);

  const dropdownRender = useCascaderDropdownRender(
    treeData,
    () => normalizeMaterialsCategory(form.getFieldValue('materialsCategory')),
    (v) => form.setFieldsValue({ materialsCategory: v }),
    () => form.submit(),
  );
  return (
    <>
      <Form
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
        form={form}
        onFinish={(values) => {
          const { materialsCategoryList, ...categoryParams } = getMaterialsCategoryParams(values?.materialsCategory)
          props.onValueChange({
            ...values,
            ...categoryParams,
          })
        }}
      >
        <Row
          style={{ marginBottom: 10, width: '100%' }}
          align='middle'
          justify='space-between'
        >
          <Space>
            <Form.Item name='name' noStyle>
              <Input
                autoComplete='off'
                placeholder='药品名称/助记码/条形码/物资编号'
                style={{ width: 280 }}
                onChange={() => form.submit()}
                prefix={<SearchOutlined />}
                allowClear
              />
            </Form.Item>
            <Form.Item name='' noStyle>
              <Checkbox
                style={{
                  color: '#666',
                  display: 'flex',
                  alignItems: 'center',
                }}
                checked={jzcxChecked}
                onChange={(e) => {
                  props?.continueOrder && props?.continueOrder(e.target.checked, 'jzcx')
                  setJzcxChecked(e.target.checked)
                }}
              >
                是否精准查询
              </Checkbox>
            </Form.Item>
            <Form.Item name='supplierName' noStyle>
            <Input
              placeholder='供应商'
              allowClear
              style={{ width: 120 }}
              onChange={() => form.submit()}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
            <Form.Item name='storehouseId' noStyle>
              <Select
                style={{ width: 100 }}
                placeholder='库房名称'
                allowClear
                showSearch
                dropdownClassName={styles.select}
                optionFilterProp='children'
                onChange={() => form.submit()}
                onSelect={(key: any) => {
                  dispatch(setCategory(key))
                }}
              >
                {durgData.map((v: any) => {
                  return (
                    <Option value={v.id} key={v.id}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Form.Item noStyle name='billingCategory'>
              <Select
                placeholder='开票项目'
                allowClear
                style={{ width: 100 }}
                dropdownClassName={styles.select}
                onChange={() => form.submit()}
              >
                {InvoiceBillingCategories.map((v) => {
                  return (
                    <Option value={v} key={v}>
                      {BillingCategoryName(v)}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Form.Item name='materialsCategory' noStyle>
              <Cascader
                className={styles.materialsCategoryCascader}
                options={treeData}
                onChange={() => form.submit()}
                multiple
                maxTagTextLength={12}
                changeOnSelect
                placeholder='物资类别'
                style={{ width: 100 }}
                dropdownRender={dropdownRender}
              />
            </Form.Item>
            <Form.Item name='userId' noStyle>
              <Select
                showSearch
                placeholder='业务人员'
                allowClear
                dropdownClassName={styles.select}
                onChange={() => form.submit()}
                // suffixIcon={<CaretDownFilled />}
              >
                {userData.map((v: any) => {
                  return (
                    <Option value={v.id} key={v.id}>
                      {v.name}
                    </Option>
                  )
                })}
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: '6rem' }}
              labelPrefix=''
              namePrefix='time'
              placeholder='今天'
              initialValue={DateRangeType.ThisMonth}
              onChange={() => form.submit()}
              allowClear={false}
            />
             <Button
              loading={props.loading}
              type='primary'
              onClick={() => form.submit()}
            >
              查询
            </Button>
            <FilterColumn
              filterColumn={props?.filterColumn}
              filterSelectList={props?.filterSelectList}
              // 筛选列变化时的数据
              onColumnVisibilityChange={(v: any) => {
                // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
                const sortList = props?.filterColumn?.map((val: any) => {
                  return {
                    ...val,
                    visible: v?.includes(val.field)
                  }
                })
                props?.submitPageList && props?.submitPageList(sortList)
              }}
            />
          </Space>
          <Space>
            <Button type='primary' onClick={() => props.outClued()} loading={props.exportloading}>
              导出
            </Button>
          </Space>
        </Row>
      </Form>
    </>
  )
};
